"use client";
const l = async (e, n, s) => {
  const o = JSON.stringify(e.primaryFieldValues, null, 2), i = JSON.stringify(e.fieldsToGenerate, null, 2), t = (await n.chat.completions.create(
    {
      model: "inkeep-context-expert",
      messages: [
        {
          role: "system",
          content: `You are a helpful assistant that suggests form field values based on context. You will receive form field information including field names, descriptions, input types, and available options for select fields.

For each field, consider its description, input type, and available options (for select fields).

You must respond with a JSON object where keys are the field names and values match the expected input type and length for that field.`
        },
        {
          role: "user",
          content: `Based on these primary field values:
${o}

Suggest values for these additional fields:
${i}`
        }
      ],
      response_format: {
        type: "json_object"
      }
    },
    s ? { headers: s } : void 0
  )).choices[0]?.message?.content;
  return {
    suggestedValues: t ? JSON.parse(t) : {}
  };
};
export {
  l as generateContextModelResponse
};
